// BookingAudit.tsx
import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../store/hooks";
import AuditHistory from "./AuditHistory";
import { AuditEntry, AuditAction, UserRole } from "./types/AuditTypes";
import apiService from "../../../../../service/Api";

interface BookingAuditProps {
  bookingId: string;
}

interface SystemLog {
  id: number;
  user?: number;
  user_email?: string;
  action: string;
  action_display: string;
  table_name: string;
  record_id: string | number | null;
  timestamp: string;
  ip_address?: string;
  additional_info?: string;
  created_at?: string;
  updated_at?: string;
}

export default function BookingAudit({ bookingId }: BookingAuditProps) {
  const [auditEntries, setAuditEntries] = useState<AuditEntry[]>([]);
  const [rawLogs, setRawLogs] = useState<SystemLog[]>([]);

  // users from redux
  const users = useAppSelector((state) => state.users.users);

  useEffect(() => {
    async function fetchLogs() {
      try {
        const res = await apiService.get<{ results: SystemLog[] }>(
          `api/logs/system-log/?table_name=booking&record_id=${bookingId}&ordering=-timestamp`,
        );

        const logs = res.data.results;

        // store full logs
        setRawLogs(logs);

        const validActions: AuditAction[] = [
          "created",
          "updated",
          "status_change",
          "deleted",
          "assigned",
        ];

        const entries: AuditEntry[] = logs.map((log) => {
          const user = users.find((u) => u.id === log.user);

          const userName = user
            ? `${user.first_name} ${user.last_name}`
            : log.user_email || "System";

          const userRole: UserRole = user ? (user.role as UserRole) : "System";
          console.log(rawLogs);
          return {
            id: String(log.id),
            action: validActions.includes(log.action as AuditAction)
              ? (log.action as AuditAction)
              : "updated",
            userName,
            userRole,
            description: log.additional_info || log.action_display,
            timestamp: new Date(log.timestamp),
          };
        });

        setAuditEntries(entries);
      } catch (error) {
        console.error("Failed to fetch logs:", error);
      }
    }

    fetchLogs();
  }, [bookingId, users, rawLogs]);

  return <AuditHistory entries={auditEntries} />;
}
